import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import {
  CorporatePositionDto,
  CreateCorporatePositionDto,
  UpdateCorporatePositionDto,
  CorporatePositionsParameters,
  PagedResultDto
} from '../../models';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class CorporatePositionsService {
  private readonly baseUrl = '/api/corporate-positions';
  private readonly http = inject(HttpClient);

  getAll(
    parameters?: CorporatePositionsParameters
  ): Observable<PagedResultDto<CorporatePositionDto>> {
    const params = HttpHelper.toHttpParams(parameters ?? {});
    return this.http.get<PagedResultDto<CorporatePositionDto>>(
      `${this.baseUrl}`,
      { params }
    );
  }

  create(
    requestBody: CreateCorporatePositionDto
  ): Observable<CorporatePositionDto> {
    return this.http.post<CorporatePositionDto>(`${this.baseUrl}`, requestBody);
  }

  get(id: string): Observable<CorporatePositionDto> {
    return this.http.get<CorporatePositionDto>(`${this.baseUrl}/${id}`);
  }

  update(
    id: string,
    requestBody: UpdateCorporatePositionDto
  ): Observable<CorporatePositionDto> {
    return this.http.put<CorporatePositionDto>(
      `${this.baseUrl}/${id}`,
      requestBody
    );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  default(): Observable<CorporatePositionDto[]> {
    return this.http.get<CorporatePositionDto[]>(`${this.baseUrl}/defaults`);
  }
}
